import React from 'react';
import './PesoEngineering.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection'; // Correct import for the component
import peso_dummy_1 from '../../assets/images/peso_dummy_1.jpg'; // Correct path for the background image
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_peso1_banner from '../../assets/images/img_peso1_banner.png';
import { FaShieldAlt, FaGavel, FaHandshake, FaCogs, FaComments, FaFileAlt, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection'; // Import the ActsAndRulesSection component
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function PesoEngineering() {
  const pesoBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Safety Compliance',
      text: 'Ensure that your operations meet the highest safety standards.',
    },
    {
      icon: <FaGavel />,
      title: 'Legal Assurance',
      text: 'Avoid legal risks associated with non-compliance.',
    },
    {
      icon: <FaHandshake />,
      title: 'Business Credibility',
      text: 'Gain trust with stakeholders and clients.',
    },
    {
      icon: <FaCogs />,
      title: 'Operational Efficiency',
      text: 'Streamline operations by following safety protocols.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss your business’s specific needs.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation & Paperwork',
      description: 'Complete all required documents for PESO submission.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Safety Review',
      description: 'We perform a thorough safety check of your processes and facilities.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Submission & Follow-up',
      description: 'We submit the application and handle any follow-up queries.',
    },
    {
      icon: <FaCertificate />,
      title: 'Certification Issuance',
      description: 'Receive your PESO approval and proceed with operations.',
    },
  ];

  const acts = [
    "Explosives Act",
    "Petroleum Act",
    "Petroleum Rules 2002",
    "SMPV Rules 2016"
  ];



  const explanation = "These laws ensure businesses adhere to safety, environmental, and regulatory standards, helping prevent accidents and penalties related to hazardous substances.";
  const checklistItems = [
    { name: 'Engineering License', description: 'Please provide your current engineering license.' },
    { name: 'Proof of Experience', description: 'Document showing at least 5 years of engineering experience.' },
    { name: 'Company Insurance Documents', description: 'Provide proof of valid insurance coverage for the company.' },
    { name: 'Company Registration Documents', description: 'Provide incorporation certificate and relevant business licenses.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="PESO Certification & Approvals"
        subheading="Ensure compliance and safety with Petroleum and Explosives Safety Organization approvals."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/peso" }}
        backgroundImage={peso_dummy_1}  // Pass the image path here
      />

      <ServicesOverviewSection
        title="What is PESO Certification?"
        description="PESO certification is required for businesses dealing with hazardous materials and explosives. Our team helps you navigate the complex approval process to ensure safety and compliance."
        image={img_peso1_banner} // Image for the PESO certification process
        altText="PESO Certification Process"
      />

      <ServicesBenefitsSection
        title="Why You Need PESO Certification"
        description="Discover the advantages of PESO certification for your business."
        benefits={pesoBenefits}
      />


      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Explosives and Petroleum Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple PESO Certification Process"
        steps={steps}
      />
      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Peso Engineering Onboarding Document Checklist"
        items={checklistItems}
      />


      <Footer />
    </>
  );
}
